import API from '@/api/apiCreate'
import { getParams } from '@/api/getParams'
import { isError } from '@/helpers/checkQuery'
import { ResponseWrapper } from '@/api/types/base.types'
import {
  TaskTrackerBoardAutomationsDetails,
  UpdateTaskTrackerBoardAutomationOnCompleteRequest,
  UpdateTaskTrackerBoardAutomationOnMoveRequest,
} from '../store/taskTracker.types'
import { mapAutomationsDetailsFromApi } from './taskTracker.api.mappers'
import { getApiErrorMessage, TASK_TRACKER_API_REQUEST_CONFIG } from './taskTracker.api.utils'
import {
  ApiTaskTrackerAutomationsIndexResponse,
  ApiTaskTrackerAutomationsUpdateLegacyBody,
} from './taskTracker.api.types'

export const taskTrackerAutomationsApi = {
  async getBoardAutomations(
    boardId: number,
  ): Promise<TaskTrackerBoardAutomationsDetails> {
    const res = await API.get<
      ResponseWrapper<ApiTaskTrackerAutomationsIndexResponse>
    >(
      `task-tracker-automations/index${getParams({ board_id: boardId })}`,
      TASK_TRACKER_API_REQUEST_CONFIG,
    )

    if (isError(res)) {
      throw new Error(
        getApiErrorMessage(res, 'Не удалось загрузить автоматизации доски'),
      )
    }

    if (!res.data?.data?.board) {
      throw new Error('Не удалось загрузить автоматизации доски')
    }

    return mapAutomationsDetailsFromApi(res.data.data)
  },

  async updateBoardAutomations(
    boardId: number,
    payload:
      | UpdateTaskTrackerBoardAutomationOnCompleteRequest
      | UpdateTaskTrackerBoardAutomationOnMoveRequest
      | ApiTaskTrackerAutomationsUpdateLegacyBody,
  ): Promise<TaskTrackerBoardAutomationsDetails> {
    const res = await API.post<
      ResponseWrapper<ApiTaskTrackerAutomationsIndexResponse>
    >(
      `task-tracker-automations/update${getParams({ board_id: boardId })}`,
      payload,
      TASK_TRACKER_API_REQUEST_CONFIG,
    )

    if (isError(res)) {
      throw new Error(
        getApiErrorMessage(res, 'Не удалось сохранить автоматизации доски'),
      )
    }

    if (!res.data?.data?.board) {
      throw new Error('Не удалось сохранить автоматизации доски')
    }

    return mapAutomationsDetailsFromApi(res.data.data)
  },
}
